export const SHIPPING = "Shipping";
export const COLLECTIONS = "Collections";
export const DELIVERIES = "Deliveries";
export const SHOP_RETURNS = "Shop Returns";
export const PICKUP_RETURNS = "Pickup Returns";
export const ADDRESS_BOOK = "Address Book";
export const DATA = "Data";
export const LOCATION_MAPS = "Location Maps";
export const DPD = "DPD";
export const DPD_LOCAL = "DPD Local";
export const MY_DPD = "MyDPD";
export const MY_DPD_LOCAL = "MyDPD Local";
export const HELP = "Help";
export const LOGOUT = "Logout";
export const LOGIN = "Login";
export const HELP_AND_TIPS = "Help & Tips";
export const HOME = "Home";
export const STEP$OF$ = (stepNumber, totalSteps) => `Step ${stepNumber} of ${totalSteps}`;
export const MYDPD_CUSTOMER_APP = "MyDPD Customer App";
export const $_IS_NOT_CONFIGURED = what => `${what} is not configured`;
export const WRONG_URL = "Unfortunately it looks like your account isn't ready just yet for accessing our new shipping platform so we'll just need to take you back";
export const BACK_TO_LOGIN = " Back to login";
export const RE_CONFIGURE = "Re-configure";
export const REFRESH_STATUS = "Refresh Status";
export const PAIR = "Pair";
export const UPDATE_MYDPD_APP = "Update MyDPD app";
export const UPDATE_MYDPD_APP_MESSAGE = "Your app version is outdated and not supported anymore. Would you like to update your app now?";